<div class="picker">
  <div class="picker-label">{{ label }}</div>

  <div class="search-row">
    <input class="search-input" type="text" [(ngModel)]="query" (keydown.enter)="search()"
      placeholder="Type a name or email…" />
    <button class="search-btn" (click)="search()" [disabled]="searching || !query.trim()" title="Search">
      <img class="btn-icon" src="assets/images/search.png" alt="Search" />
    </button>
  </div>

  <div class="results" *ngIf="candidates.length > 0 || searching">
    <div *ngIf="searching && candidates.length === 0" class="loading-hint">Searching…</div>
    <ng-container *ngIf="!searching && candidates.length > 0">
      <div class="results-caption">Showing {{ visibleCandidates.length }} of {{ candidates.length }} matches</div>
      <div class="result-list">
        <label class="result-item" *ngFor="let p of visibleCandidates">
          <input type="checkbox" [checked]="isSelected(p.email)" (change)="toggleSelected(p.email)" />
          <span>{{ p.display_name }} &lt;{{ p.email }}&gt;</span>
          <span class="membership-warning" *ngIf="membershipWarning(p.email) as warning">{{ warning }}</span>
        </label>
      </div>
      <button class="link-btn" *ngIf="visibleCandidates.length < candidates.length" (click)="showMore()">
        Show more ({{ remainingCount }} more)
      </button>
      <button class="add-btn" (click)="addSelected()" [disabled]="selectedEmails.size === 0">
        Add to {{ label }}
      </button>
    </ng-container>
  </div>

  <div class="current-label">Current {{ label }}</div>
  <div class="chips">
    <span class="chip" [class.chip-warning]="membershipWarning(email)" *ngFor="let email of current"
      [title]="membershipWarning(email) ?? ''">
      {{ email }}
      <button class="chip-remove" (click)="removeCurrent(email)">&times;</button>
    </span>
    <span class="empty-hint" *ngIf="current.length === 0">None selected</span>
  </div>
</div>